<template>
    <div class="text-center mt-5">
        <h1>{{$t('pageNotFound.title')}}</h1>
        <p>{{$t('pageNotFound.description')}}</p>
    </div>
</template>